import {JsonProperty} from 'json-typescript-mapper';
import { Marketday } from './';

export enum MarketdateStatusEnum {
  Unopened = <any>'Unopened',
  Opened = <any>'Opened',
  Absent = <any>'Absent',
  Closed = <any>'Closed',
  Paused = <any>'Paused',
  Canceled = <any>'Canceled',
  Confirmed = <any>'Confirmed',
  CanceledWeather = <any>'CanceledWeather',
  CanceledOtherEvent = <any>'CanceledOtherEvent',
  Manual = <any>'Manual'
};

export enum MarketmasterStatusEnum {
  Work = <any>'Work',
  SickLeave = <any>'SickLeave',
  PaidLeave = <any>'PaidLeave',
  NoPay = <any>'NoPay'
};

export class Marketdate {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('originalDate')
  public originalDate?: string;

  @JsonProperty('evasiveDate')
  public evasiveDate?: string;

  @JsonProperty('holiday')
  public holiday?: boolean;

  @JsonProperty('canceled')
  public canceled?: boolean;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty('status')
  public status?: MarketdateStatusEnum;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  @JsonProperty('openedBy')
  public openedBy?: string;

  @JsonProperty('closedBy')
  public closedBy?: string;

  @JsonProperty('closeReminderSms')
  public closeReminderSms?: any;

  @JsonProperty('transferred')
  public transferred?: boolean;

  @JsonProperty('transferredAt')
  public transferredAt?: string;

  @JsonProperty('mm1Status')
  public mm1Status?: MarketmasterStatusEnum;

  @JsonProperty('mm2Status')
  public mm2Status?: MarketmasterStatusEnum;

  @JsonProperty('mm3Status')
  public mm3Status?: MarketmasterStatusEnum;

  constructor() {
    this.id = void 0;
    this.marketdayNumber = void 0;
    this.originalDate = void 0;
    this.evasiveDate = void 0;
    this.holiday = false;
    this.canceled = false;
    this.comment = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.status = void 0;
    this.marketday = void 0;
    this.openedBy = void 0;
    this.closedBy = void 0;
    this.closeReminderSms = void 0;
    this.transferred = void 0;
    this.transferredAt = void 0;
    this.mm1Status = void 0;
    this.mm2Status = void 0;
    this.mm3Status = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketdate.model.ts